import { render } from "./EditProductCard.vue?vue&type=template&id=fb76df9e&scoped=true"
import script from "./EditProductCard.vue?vue&type=script&lang=js"
export * from "./EditProductCard.vue?vue&type=script&lang=js"

import "./EditProductCard.vue?vue&type=style&index=0&id=fb76df9e&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb76df9e"]])

export default __exports__